import React from "react";

export default function Privacy() {
  return (
    <div className="pt-24 pb-24 max-w-3xl mx-auto px-4 md:px-8" data-testid="privacy-page">
      <p className="text-xs font-bold tracking-[0.15em] uppercase text-[#A94438] mb-1">Legal</p>
      <h1 className="font-heading text-3xl md:text-5xl font-black tracking-tighter mb-6">Privacy Policy</h1>
      <p className="text-xs text-[#5C5C54] mb-8">Last updated: {new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" })}</p>

      <div className="prose prose-sm max-w-none text-[#3C3C38] space-y-6">
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">1. Who we are</h2>
          <p>AfriPantry is the data controller for personal data collected through our website. This policy explains what we collect, why, and your rights under the UK GDPR and the Data Protection Act 2018.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">2. What we collect</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Account data</strong> — name, email, password hash, profile picture (if signing in with Google).</li>
            <li><strong>Order data</strong> — delivery addresses, postcode, delivery notes, order history.</li>
            <li><strong>Payment data</strong> — processed by Stripe. We never see or store your full card number.</li>
            <li><strong>Support data</strong> — messages you send via the chat widget or WhatsApp.</li>
            <li><strong>Usage data</strong> — device type, pages viewed, anonymised performance analytics.</li>
          </ul>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">3. How we use your data</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>To process and deliver your orders (legal basis: contract).</li>
            <li>To provide customer support and respond to queries (legal basis: legitimate interests).</li>
            <li>To improve the service, fix bugs and prevent fraud (legal basis: legitimate interests).</li>
            <li>To send transactional emails such as order confirmations (legal basis: contract).</li>
            <li>Marketing emails are only sent with your explicit opt-in consent, and you can unsubscribe at any time.</li>
          </ul>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">4. Sharing with vendors</h2>
          <p>When you place an order, we share your name, delivery address, phone (if provided) and order details with the relevant vendor(s) so they can fulfil the order. Vendors are required to use this data only for order fulfilment.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">5. Third-party processors</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Stripe</strong> — payment processing.</li>
            <li><strong>Google</strong> — optional sign-in via Google OAuth.</li>
            <li><strong>MongoDB Atlas</strong> — secure database hosting.</li>
            <li><strong>PostHog</strong> — anonymised product analytics.</li>
          </ul>
          <p>All processors are contractually obliged to protect your data.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">6. International transfers</h2>
          <p>Some processors may transfer your data outside the UK/EEA. Where this happens, transfers are protected by Standard Contractual Clauses or equivalent safeguards approved under UK GDPR.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">7. Retention</h2>
          <p>Order records are retained for 6 years to meet UK tax and consumer-protection requirements. Inactive accounts are deleted or anonymised after 36 months. You can request deletion earlier (see section 9).</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">8. Cookies</h2>
          <p>We use strictly-necessary cookies for authentication and cart state. We do not use third-party advertising cookies. Analytics cookies are used in an anonymised form only.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">9. Your rights</h2>
          <p>Under UK GDPR you have the right to access, rectify, erase, restrict processing, object to processing, and data portability. To exercise any of these, contact us via WhatsApp at <a href="https://wa.me/447979127731" className="text-[#A94438] font-semibold">+44 7979 127731</a> or through the in-app support chat. You can also complain to the UK Information Commissioner's Office (ICO) at <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer" className="text-[#A94438] font-semibold">ico.org.uk</a>.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">10. Security</h2>
          <p>Passwords are hashed with industry-standard algorithms. Traffic is encrypted via HTTPS. Access to production systems is restricted and logged.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">11. Children</h2>
          <p>AfriPantry is not intended for children under 16. We do not knowingly collect data from children under 16.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">12. Updates</h2>
          <p>We will update this policy from time to time. Material changes will be communicated via email or a banner on our site.</p>
        </section>
      </div>
    </div>
  );
}
